import React, {useEffect} from 'react';
import { Grid, Button } from '@mui/material'

import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import CarRentalIcon from '@mui/icons-material/CarRental';
import NoCrashIcon from '@mui/icons-material/NoCrash';

import VehiculosPage from '../SubComponents/Vehiculos/Vehiculos';
import EntradaVehiculos from '../SubComponents/Vehiculos/EntradaVehiculos';
import SalidaVehiculos from '../SubComponents/Vehiculos/SalidaVehiculos';

const pageVehiculos = ['Vehiculos', 'Entrada', 'Salida', 'None'];

const Vehiculos = ({ handleChangeOption, placaVehiculoCodigoDeBarras, onCreatedRecord }) => {
  const [page, setPage] = React.useState('None')
  const handleChangePage = (newPage) =>  { if (pageVehiculos.includes(newPage)) setPage(newPage) }

  useEffect(() => {
    if (placaVehiculoCodigoDeBarras !== '') {
      setPage('Salida');
    }
  }, [placaVehiculoCodigoDeBarras]);

  return (
    <>
      {  page === 'Vehiculos' ? <VehiculosPage handleChangePage={handleChangePage}/> :
         page === 'Entrada' ? <EntradaVehiculos handleChangePage={handleChangePage} onCreatedRecord={onCreatedRecord}/> :
         page === 'Salida' ? <SalidaVehiculos handleChangePage={handleChangePage} placaVehiculoCodigoDeBarras={placaVehiculoCodigoDeBarras} onCreatedRecord={onCreatedRecord}/> :
         (
          <Grid container style={{ height: '100vh' }}>
          {/* Contenedor izquierdo */}
          <Grid item xs={6} style={{ height: '100%' }}>
            <Button
              startIcon={<DirectionsCarIcon style={{color: 'white', fontSize: '180%'}}/>}
              style={{
                height: '100%',
                width: '98%',
                padding: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                backgroundColor: 'rgba(0,0,0,0.5)',
                color: 'white',
                fontFamily: 'Bebas Neue, sans-serif',
                fontWeight: 'bold',
              }}
              onClick={() => handleChangePage('Vehiculos')}
            >
              Vehiculos
            </Button>
          </Grid>

          {/* Contenedor derecho */}
          <Grid item xs={6} container direction="column" style={{ height: '100%' }}>
            <Grid
              item
              style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
              }}
            >
              <Button
                startIcon={<CarRentalIcon style={{color: 'white', fontSize: '200%'}}/>}
                style={{
                  height: '95%',
                  width: '98%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  backgroundColor: 'rgba(0,0,0,0.5)',
                  color: 'white',
                  fontFamily: 'Bebas Neue, sans-serif',
                  fontWeight: 'bold',
                }}
                onClick={() => handleChangePage('Entrada')}
              >
                Entrada de Vehiculos
              </Button>
            </Grid>
            <Grid
              item
              style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
              }}
            >
              <Button
                startIcon={<NoCrashIcon style={{color: 'white', fontSize: '200%'}}/>}
                style={{
                  height: '95%',
                  width: '98%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  backgroundColor: 'rgba(0,0,0,0.5)',
                  color: 'white',
                  fontFamily: 'Bebas Neue, sans-serif',
                  fontWeight: 'bold',
                }}
                onClick={() => handleChangePage('Salida')}
              >
                Salida de Vehiculos
              </Button>
            </Grid>
          </Grid>
        </Grid>
         )
      }
    </>
  );
};

export default Vehiculos;
